import type { CurrentValuationSnapshot } from "@/schemas";
import { useCurrentValuationQuery } from "./queries";

export function useCurrentValuation(selectedBookId: string) {
  const currentValuationQuery = useCurrentValuationQuery(selectedBookId);

  return {
    currentValuation:
      (currentValuationQuery.data as CurrentValuationSnapshot | null) ?? null,
    loading: currentValuationQuery.isLoading,
  };
}
